/* eslint-disable no-restricted-globals,import/prefer-default-export */
import React from 'react';
import ReactDOM from 'react-dom';
import store from 'src/store';
import '@babel/polyfill';
import 'src/boot/dayjs';
import 'src/boot/css';
import 'src/boot/sentry';
import { Provider } from 'react-redux';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import oidcConfig from 'src/auth/oidcConfig';
import { updateServiceWorker } from 'src/store/reducers/ServiceWorkerReducer';
import { AuthProvider } from 'react-oidc-context';
import App from 'src/containers/App';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import conf from 'src/conf/conf';
import registerServiceWorker from 'src/registerServiceWorker';
import AppLanguageStorage from 'src/translations/AppLanguageStorage';
import { setAppLang } from 'src/store/actions/translationActions';
store.dispatch(setAppLang(AppLanguageStorage.language));
const onUpdate = () => {
    store.dispatch(updateServiceWorker());
};
ModuleRegistry.registerModules([AllCommunityModule]);
registerServiceWorker(onUpdate);
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(AuthProvider, { ...oidcConfig },
        React.createElement(Router, { basename: conf.basename },
            React.createElement(Route, { path: "/", component: App })))), document.getElementById('app'));
